import { render, staticRenderFns } from "./quoteManage.vue?vue&type=template&id=65eb7b95"
import script from "./quoteManage.vue?vue&type=script&lang=js"
export * from "./quoteManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports